import React from 'react';
import { DayPickerRangeController } from 'react-dates';
import moment from 'moment';

interface DateRangePickerState {
  open: boolean;
  focused: 'startDate' | 'endDate' | null;
}

export interface DateRangeInput {
  startDate: moment.Moment;
  endDate: moment.Moment;
  selectedOptionId: number | null;
}
interface DateRangePickerProps {
  startDate: moment.Moment | any;
  endDate: moment.Moment | any;
  selectedOptionId?: number;
  dateOptions?: { id: number, startDate: moment.Moment, endDate: moment.Moment, label: string }[]
  inputShowsStartDate?: boolean;
  onChange: (dates: DateRangeInput) => void;
  inputStyle?: React.CSSProperties;
  isInvalid?: boolean;
}

class DateRangePicker extends React.PureComponent<DateRangePickerProps, DateRangePickerState> {

  readonly state: DateRangePickerState = {
    open: false,
    focused: 'startDate'
  };

  datePickerContainerRef: React.RefObject<HTMLDivElement>;

  constructor(props: DateRangePickerProps) {
    super(props);

    this.datePickerContainerRef = React.createRef();
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event: any) => {
    if (this.datePickerContainerRef != null && this.datePickerContainerRef.current != null) {
      if (!this.datePickerContainerRef.current.contains(event.target)) {
        if (this.state.open) {
          this.setState({ open: false });
        }
      }
    }
  }
  toggle(open: boolean) {
    this.setState({ open, focused: 'startDate' });
  }

  render() {
    let inputText = '';
    if (this.props.selectedOptionId && this.props.dateOptions) {
      const selectedOption = this.props.dateOptions.find(o => o.id === this.props.selectedOptionId);
      if (selectedOption) {
        inputText = selectedOption.label;
      }
    } else {
      if (!this.props.startDate && !this.props.endDate) {
        inputText = 'Vali ajavahemik';
      } else {
        inputText = (this.props.startDate && this.props.startDate.format('DD.MM.YY')) + ' - ' +
          (this.props.endDate && this.props.endDate.format('DD.MM.YY'));
      }
    }
    return (
      <>
        <div className="position-relative">
          <input
            className={`form-control datepicker-input${(this.props.isInvalid && ' is-invalid') || ''}`}
            value={inputText}
            onChange={() => null}
            onFocus={() => this.toggle(true)}
            style={this.props.inputStyle || {}}
            readOnly
          />
          {this.state.open
            && (
              <div className="date-range-picker-container" ref={this.datePickerContainerRef}>
                {(this.props.dateOptions && <div className="premade-selections shadow-sm">
                  <ul className="list-unstyled">
                    {this.props.dateOptions.map(o =>
                      <li
                        key={o.id} 
                      >
                        <button
                          className={`btn btn-link btn-block rounded-0 px-2 py-3 mb-0 mb-md-1${o.id === this.props.selectedOptionId ? ' active' : ''}`}
                          onClick={() => this.setState({ open: false }, () => this.props.onChange({ startDate: o.startDate, endDate: o.endDate, selectedOptionId: o.id }))}
                        >
                          {o.label}
                        </button>
                      </li>
                    )}
                  </ul>
                </div>) || null}
                <DayPickerRangeController
                  startDate={this.props.startDate}
                  endDate={this.props.endDate}
                  onDatesChange={(dates) => {
                    const startDate = dates.startDate || this.props.startDate;
                    const endDate = dates.endDate || this.props.endDate;
                    if (dates.endDate && !dates.endDate.isSame(this.props.endDate)) {
                      this.toggle(false);
                    }
                    this.props.onChange({ startDate, endDate, selectedOptionId: null });

                  }}
                  focusedInput={this.state.focused || (this.props.inputShowsStartDate ? 'startDate' : 'endDate')}
                  onFocusChange={(focused) => this.setState({ focused })}
                  onOutsideClick={() => null}
                  hideKeyboardShortcutsPanel
                  numberOfMonths={window.innerWidth >= 768 ? 2 : 1}
                  initialVisibleMonth={null}
                />
              </div>
            )}
        </div>
      </>
    );
  }
}

export default DateRangePicker;